import { reducerRegistry } from '../../../../reducerRegistry';

import collectionsReducersMap from './collections/reducersMap';
import formsReducersMap from './forms/reducersMap';
import listsReducersMap from './lists/reducersMap';
import viewsReducersMap from './views/reducersMap';

const combineMap = {
  collections: collectionsReducersMap,
  forms: formsReducersMap,
  lists: listsReducersMap,
  views: viewsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('tasksModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/combineRegistry.js